module.exports = __webpack_public_path__ + "static/media/avatar38.ec2141c2.png";